import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API });

export const CATEGORIES = [
  { value: "all", label: "All Pieces" },
  { value: "polki-sets", label: "Polki Sets" },
  { value: "necklaces", label: "Necklaces" },
  { value: "bracelets", label: "Bracelets" },
  { value: "rings", label: "Rings" },
  { value: "earrings", label: "Earrings" },
];

export const categoryLabel = (value) =>
  CATEGORIES.find((c) => c.value === value)?.label || value;

export const GEMSTONES = [
  { value: "all", label: "All Stones" },
  { value: "emerald", label: "Emeralds" },
  { value: "ruby", label: "Rubies" },
  { value: "sapphire", label: "Sapphires" },
  { value: "pearl", label: "Pearls" },
];

export const imgProps = (src, sizes = "(max-width: 640px) 100vw, 50vw") => {
  if (!src || !src.startsWith("/assets/")) return { src };
  const small = src.replace(/\.(jpg|jpeg|png|webp)$/i, "-768.$1");
  return { src, srcSet: `${small} 768w, ${src} 1792w`, sizes, decoding: "async" };
};

export const inr = (n) => `₹${Number(n).toLocaleString("en-IN")}`;
